import React from "react";
import EditLibraryForm from "./EditLibraryForm";
import { Tab, Tabs } from "@nextui-org/react";
import {  useNavigate, useParams } from "react-router-dom";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";


const EditLibrary = () => {
  const navigator = useNavigate();

  const { _orgId: currOrg } = useParams();
 
  
  return (
    <BreadCrumbsPage>
      <div>
        <div className="text-3xl font-medium">Edit Library</div>
        <div className="mt-8">
          <Tabs variant="light">
            <Tab key="general" title="General">
              <EditLibraryForm />
            </Tab>
            <Tab key="factor mapping" title="Factors mapping"></Tab>
          </Tabs>
        </div>
      </div>
    </BreadCrumbsPage>
  );
};

export default EditLibrary;
